import { createSelector } from 'reselect';

export const selectMerchantTileList = state => state.merchantTileList;
export const selectMerchantTileListConfig = createSelector(
  selectMerchantTileList,
  merchantTileList => merchantTileList.config,
);
